import { Box, Divider, Typography } from "@mui/material";

export default function HistoryList({ history }: any) {
  return (
    <>
      {history?.length > 0 ? (
        <>
          <Box display={"flex"} mt={2.4}>
            <Typography width={250} fontWeight={550}>
              Date
            </Typography>
            <Typography width={250} fontWeight={550}>
              User
            </Typography>
            <Typography fontWeight={550} ml={1}>Description</Typography>
          </Box>
          <Divider sx={{ borderBottomWidth: 2, mt: 0.5 }} />
          {history?.map((historyObj: any, index: number) => (
            <Box>
              <Box mt={1.5} display={"flex"}>
                <Typography
                  sx={{
                    width: 250,
                    minWidth: 250,
                    color: "rgba(0, 0, 0, 0.6)",
                  }}
                  noWrap
                >
                  {historyObj?.createdAt || "-"}
                </Typography>
                <Typography
                  sx={{
                    width: 250,
                    minWidth: 250,
                    color: "rgba(0, 0, 0, 0.6)",
                  }}
                  noWrap
                >
                  {historyObj?.userFullName || "-"}
                </Typography>
                <Typography
                  sx={{
                    ml: 1,
                    color: "rgba(0, 0, 0, 0.6)",
                  }}
                >
                  {historyObj?.description || "-"}
                </Typography>
              </Box>
              {history?.length - 1 !== index && <Divider sx={{ mt: 1 }} />}
            </Box>
          ))}
        </>
      ) : (
        <Typography sx={{ mt: 3 }}>No History Available!</Typography>
      )}
    </>
  );
}
